module.exports = __webpack_public_path__ + "media/images/cover/pool-house-c6d05b32859eea36fc9c27ce53454692.jpg";